<template>
  <div>
    <div class="sm:border-b sm:border-gray-400 sm:pb-5 sm:mb-5">
      <h3 class="text-lg leading-6 font-semibold text-blue-600">
        {{ title }}
      </h3>
      <p class="mt-1 max-w-2xl text-sm text-gray-600">
        {{ description }}
      </p>
    </div>

    <media-uploader
      v-if="upload"
      :files="files"
      :src="upload"
      :errors="errors"
      :vapor="vapor"
      :collection-name="collectionName"
      :upload-key="uploadKey"
      class="mt-4"
    />

    <!--        <media-list :destroy="destroy" :featured="featured" :files="files" />-->
  </div>
</template>

<script>
import MediaList from '@/Components/Media/MediaList'
import MediaUploader from '@/Components/Media/MediaUploader'

export default {
  components: { MediaUploader, MediaList },

  props: {
    title: {
      type: String,
      default: 'Manage Media'
    },

    description: {
      type: String,
      default: 'Upload photos, galleries and videos that will sync with your ecommerce and point-of-sale.'
    },

    files: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * The route we upload the file to
     */
    upload: {
      type: String,
      default: null
    },

    /**
     * The name of the media collection
     */
    collectionName: {
      type: String,
      required: false,
      default: 'media'
    },

    /**
     * The key name to upload media to
     */
    uploadKey: {
      type: String,
      required: false,
      default: 'media'
    },

    /**
     * List of validation errors from server
     */
    errors: {
      type: Object,
      default() {
        return {}
      }
    },

    /**
     * The function we can use to determine the correct route to delete a file
     * returns null if you haven't provided a function to do this
     */
    destroy: {
      type: Function,
      default: (x) => null
    },

    /**
     * The function we can use to determine the url we use to set an image as the "featured" image
     * Returns null if you haven't passed in a function to do this
     */
    featured: {
      type: Function,
      default: (x) => null
    },

    /**
     * Configuration variables for laravel vapor
     */
    vapor: {
      type: Object,
      default() {
        return { enabled: false }
      }
    }
  }
}
</script>
